import { useMemo, useState } from 'react'

import { type CreatorStatistic } from '@api'

import { SearchInput } from '@/components/ui/search-input.tsx'
import { DataTable } from '@/components/ui/table/data-table.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'
import { getCreatorColumns } from '@/modules/accounting/ui/creators/constants.tsx'

interface Props {
  creatorsData: CreatorStatistic[]
  showCents?: boolean
  formattedRange?: string
}

export const AccountingCreatorsTable = ({
  creatorsData,
  showCents = true,
  formattedRange,
}: Props) => {
  const [query, setQuery] = useState('')

  const columns = useMemo(
    () =>
      getCreatorColumns({
        showCents,
        onSetSalary: (data) => {
          openDialog({
            type: DIALOG_TYPE.SET_CREATOR_SALARY,
            data,
            showCents,
            formattedRange,
          })
        },
      }),
    [showCents, formattedRange],
  )

  const data = useMemo(
    () =>
      creatorsData.filter(({ creatorName }) =>
        creatorName?.toLowerCase().includes(query.toLowerCase()),
      ),
    [creatorsData, query],
  )

  return (
    <DataTable
      title="All Creators"
      testId="all-creators-table"
      searchColumn="creatorName"
      enableSorting
      columns={columns}
      enablePagination
      data={data}
      extra={
        <SearchInput
          value={query}
          onInputChange={setQuery}
          placeholder="Search Creator"
          testId="all-creators-table-search-input"
        />
      }
    />
  )
}
